import React, { useEffect, useState } from 'react'
import classes from './subscription.module.css'
import { convertToFormatted, getErrorMessage } from '../../../util/functions'
import moment from 'moment'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionSelectors } from './subscriptionSlice'
import { getCurrentSub, getSubHistory } from './subscriptionApi'
import { userSelectors } from '../../../redux/userSlice'
import {
    NextPaymentLoader,
    PaymentHistoryLoader,
    ProfileSubscriptionTitleLoader,
} from '../../../components/loaders/ProfileSubscriptionLoader'
import notification from '../../../components/Notification/notification'
import { startWizard } from '../../Wizard/wizardLogic'
import CancelModal from '../../../components/CancelModal/CancelModal'
import { useHistory } from 'react-router'
import { AccountTypes } from '../../../util/constants'

const Subscription = () => {
    const history = useHistory()

    const onUpgrade = () => {
        history.push(startWizard({ isUpgrade: true }))
    }

    const [modalOpen, setModalOpen] = useState(false)

    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    useEffect(() => {
        dispatch(getCurrentSub(user.email))
        dispatch(getSubHistory(user.email))
    }, [])

    const isFetchingCurrentSub = useSelector(
        subscriptionSelectors.isFetchingCurrentSub
    )
    const currentSubHasError = useSelector(
        subscriptionSelectors.currentSubHasError
    )
    const currentSubErrorMessage = useSelector(
        subscriptionSelectors.currentSubErrorMessage
    )
    const currentSub = useSelector(subscriptionSelectors.currentSub)

    useEffect(() => {
        if (!isFetchingCurrentSub && currentSubHasError) {
            //@todo: Please log this or treat properly from the backend
            console.log('error occured', currentSubErrorMessage)
            // notification.failure({
            //     title: 'Something went wrong with fetching your active plan',
            //     description: currentSubErrorMessage,
            // })
        }
    }, [isFetchingCurrentSub])

    const isFetchingSubHistory = useSelector(
        subscriptionSelectors.isFetchingSubHistory
    )
    const subHistoryHasError = useSelector(
        subscriptionSelectors.subHistoryHasError
    )
    const subHistoryErrorMessage = useSelector(
        subscriptionSelectors.subHistoryErrorMessage
    )
    const subHistory = useSelector(subscriptionSelectors.subHistory)

    useEffect(() => {
        if (!isFetchingSubHistory && subHistoryHasError) {
            notification.failure({
                title:
                    'Something went wrong with fetching subscription history',
                description: subHistoryErrorMessage,
            })
        }
    }, [isFetchingSubHistory])

    const subscribedUser =
        user.accounttype?.toLowerCase() ===
        AccountTypes.Subscriber?.toLowerCase()

    //TODO Make a/an text dynamic
    return (
        <>
            <h1 className={classes.subscriptionHeader}>My Subscription Plan</h1>
            <div className={classes.currentSubscription}>
                {isFetchingCurrentSub ? (
                    <ProfileSubscriptionTitleLoader />
                ) : (
                    <div className={classes.currentSubscriptionText}>
                        {user.accounttype ? (
                            <>
                                <h3
                                    className={
                                        classes.currentSubscriptionTextHeader
                                    }
                                >
                                    {currentSub.subscription.title}
                                </h3>
                                <p
                                    className={
                                        classes.currentSubscriptionTextSubtext
                                    }
                                >
                                    You have been a user since,{' '}
                                    {moment(currentSub.subdate).format(
                                        'DD/MM/YYYY'
                                    )}
                                </p>
                            </>
                        ) : (
                            <h3
                                className={
                                    classes.currentSubscriptionTextHeader
                                }
                            >
                                Upturn Free
                            </h3>
                        )}
                    </div>
                )}
                <Button
                    className={classes.currentSubscriptionButton}
                    onClick={onUpgrade}
                >
                    Upgrade Plan
                </Button>
            </div>
            {user.accounttype && (
                <>
                    <div className={classes.subscriptionGrid}>
                        <span className={classes.subscriptionSectionHeader}>
                            Next payment date
                        </span>
                        {isFetchingCurrentSub ? (
                            <NextPaymentLoader />
                        ) : (
                            <div className={classes.nextPaymentDateDetails}>
                                <span
                                    className={
                                        classes.nextPaymentDateDetailsText
                                    }
                                >
                                    Amount:
                                    <span
                                        className={
                                            classes.nextPaymentDateDetailsTextBold
                                        }
                                    >
                                        {'  '}
                                        {convertToFormatted(
                                            currentSub.subscription.amount,
                                            true
                                        )}
                                    </span>
                                </span>
                                <span
                                    className={
                                        classes.nextPaymentDateDetailsText
                                    }
                                >
                                    Date:
                                    <span
                                        className={
                                            classes.nextPaymentDateDetailsTextBold
                                        }
                                    >
                                        {'  '}
                                        {moment(currentSub.expdate).format(
                                            'DD/MM/YYYY'
                                        )}
                                    </span>
                                </span>
                            </div>
                        )}
                    </div>
                    {subscribedUser && (
                        <>
                            <span className={classes.splitLine} />
                            <div className={classes.subscriptionCancel}>
                                <span className={classes.cancelText}>
                                    Want to cancel your subscription?
                                </span>
                                <button
                                    className={classes.cancelButton}
                                    onClick={() => setModalOpen(true)}
                                >
                                    Cancel Subscription
                                </button>
                            </div>
                        </>
                    )}
                    <span className={classes.splitLine} />
                    <div className={classes.paymentHistory}>
                        <h1
                            className={classNames(
                                classes.subscriptionSectionHeader,
                                classes.paymentHistoryHeader
                            )}
                        >
                            Payment History
                        </h1>
                        <div
                            className={classNames(
                                classes.paymentHistoryRow,
                                classes.paymentHistoryHeaderRow
                            )}
                        >
                            <span className={classes.paymentHistoryRowHeader}>
                                DESCRIPTION
                            </span>
                            <span className={classes.paymentHistoryRowHeader}>
                                DATE
                            </span>
                            <span className={classes.paymentHistoryRowHeader}>
                                AMOUNT
                            </span>
                        </div>
                        {isFetchingSubHistory ? (
                            <PaymentHistoryLoader />
                        ) : (
                            subHistory.map(({ subscription, subdate, log }) => (
                                <div className={classes.paymentHistoryRow}>
                                    <span
                                        className={
                                            classes.paymentHistoryRowItem
                                        }
                                    >
                                        <span
                                            className={
                                                classes.paymentHistoryRowItemLabel
                                            }
                                        >
                                            Description: {'  '}
                                        </span>
                                        {subscription.title}
                                    </span>
                                    <span
                                        className={
                                            classes.paymentHistoryRowItem
                                        }
                                    >
                                        <span
                                            className={
                                                classes.paymentHistoryRowItemLabel
                                            }
                                        >
                                            Date: {'  '}
                                        </span>
                                        {moment(subdate).format('DD/MM/YYYY')}
                                    </span>
                                    <span
                                        className={classNames(
                                            classes.paymentHistoryRowItem,
                                            classes.paymentHistoryRowItemBold
                                        )}
                                    >
                                        <span
                                            className={
                                                classes.paymentHistoryRowItemLabel
                                            }
                                        >
                                            Amount: {'  '}
                                        </span>
                                        {convertToFormatted(
                                            log.totalAmount,
                                            true
                                        )}
                                    </span>
                                </div>
                            ))
                        )}
                        {!isFetchingSubHistory && subHistory.length === 0 && (
                            <h1 className={classes.paymentHistoryEmpty}>
                                No subscription history
                            </h1>
                        )}
                    </div>
                    <CancelModal
                        onClose={_ => setModalOpen(false)}
                        modalOpen={modalOpen}
                    />
                </>
            )}
        </>
    )
}

export default Subscription
